import React from "react"
import { isMobile } from "react-device-detect"
import styled from "styled-components"

import ShutdownBannerDesktop from "resources/assets/shutdown-banner-web.png"
import ShutdownBannerMobile from "resources/assets/shutdown-banner-mobile.png"

const FAQButton = styled.a`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  background-color: #3d2398;
  opacity: 0.8;
  color: white;
  padding: 10px 14px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: bold;
  font-size: 14px;
  font-family: Arial, sans-serif;
  transition: background-color 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
`

const ShutdownImage = styled.img`
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: fixed;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
`

class HomePage extends React.Component {
  render() {
    return (
      <a href="mailto:support@sixergame.com">
        {isMobile ? (
          <ShutdownImage src={ShutdownBannerMobile} />
        ) : (
          <ShutdownImage src={ShutdownBannerDesktop} />
        )}
      </a>
    )
  }
}

export default HomePage
